/* ===== Cenzio — urun kartinda foto galerisi =====
   Kartin gorseli uzerinde iki ok; mobilde parmakla kaydirma. Ziyaretci urun
   sayfasini acmadan o urunun TUM mockup'larini gorur (Etsy ilan karti).

   GECISI BIZ CIZMIYORUZ. Gorseller kartin icinde yan yana bir SERIT halinde
   duruyor; serit tarayicinin kendi yatay kaydiricisi ve scroll-snap ile
   hizalaniyor. Ok'a basinca scrollBy({behavior:'smooth'}) cagriliyor, yani
   hareketi isletim sisteminin fizigi uretiyor. Mobilde parmak seridi birebir
   tasiyor, birakinca kendi momentumuyla oturuyor.

   Neden boyle: daha once iki katmani transform ile elle animasyon ediyorduk.
   Her seferinde bir kusur cikti (dikiste aralik, altta kalan sabit gorsel,
   basa donusun ziplamasi, egrinin sonunda savrulma). Kaydiriciya birakinca
   bunlarin hicbiri olamaz -- cunku ortada tek bir icerik var, uzerinde
   yurunen. Ustelik JS animasyonu olmadigi icin daha hizli: is kompozitorde.

   Zara'nin sitesinde kart galerisi hic yok, urun sayfasinda da gecis yok
   (olculdu: tum sayfada animasyonlu 3 eleman var, hicbiri gorsel degil).
   Yani "Zara gibi" olmanin yolu bir egri secmek degil, hareketi tasarlamayi
   birakmak.
   ================================================================= */
(function () {
  'use strict';

  /* card: kartin kok elemani, box: gorselin durdugu konumlandirilmis kutu */
  var TYPES = [
    { card: '.card-wrapper', box: '.card__inner' },   /* Dawn: koleksiyon, arama, oneriler */
    { card: '.cz-pcard',     box: '.cz-pcard__media' },/* ana sayfa "Featured canvases" */
    { card: '.cz-tcard',     box: '.cz-tcard__media' } /* ana sayfa sekmeleri */
  ];
  var MAX = 24;
  var KADEME = [300, 400, 500, 600, 700, 800, 1000, 1200, 1500];
  var cache = {};

  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var URUN_SEC = 'a[href*="/products/"]';

  /* Kartin KENDISI bir <a> olabilir: ana sayfadaki "Featured canvases"
     karuselinde .cz-pcard'in kendisi baglanti. Once elemanin kendisine,
     sonra icine, en son ustune bakiyoruz. */
  function baglanti(card) {
    if (card.matches && card.matches(URUN_SEC)) return card;
    return card.querySelector(URUN_SEC) || (card.closest ? card.closest(URUN_SEC) : null);
  }
  function handleOf(card) {
    var a = baglanti(card);
    if (!a) return null;
    var tail = (a.getAttribute('href') || '').split('/products/')[1];
    if (!tail) return null;
    return tail.split('?')[0].split('#')[0].split('/')[0];
  }

  /* INFOGRAFIKLERI ELE, mockup'larin hepsini birak. Katalogda uc sabit bilgi
     sablonu var ve ucu de her urunde ayni dosya:
     - "The Cenzio Promise" ve "Framed Canvas Details" KARE basiliyor
       (2048x2048, 2304x2304, 1200x1200) -> en == boy olan her sey elenir.
     - "Canvas Size Guide" dikey ve sabit olcu: 2104x2816.
     Elli urunde sayildi: kare 261 kez, beden rehberi 44 kez geciyor ve gercek
     mockup'larin hicbiri kare degil. Urun basina 10-13 mockup kaliyor. */
  function usable(m) {
    if (!m || m.media_type !== 'image') return false;
    if (!m.width || !m.height) return false;
    if (m.width === m.height) return false;
    if (m.width === 2104 && m.height === 2816) return false;
    return true;
  }

  function sized(url, w) {
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function load(handle) {
    if (cache[handle]) return cache[handle];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    cache[handle] = fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.media) return [];
        return d.media.filter(usable).slice(0, MAX).map(function (m) { return m.src; });
      })
      .catch(function () { return []; });
    return cache[handle];
  }

  function build(card, box) {
    var img = box.querySelector('img');
    if (!img) return null;
    var bag = baglanti(card);

    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    box.classList.add('cz-gal-host');
    card.classList.add('cz-gal-card');

    /* YIGIN SIRASI. Dawn'da baslik baglantisinin ::after'i (z-index:1) tum
       karti ortuyor; ustelik .card__inner'da transform var, yani onun icine
       koydugumuz hicbir sey disariya cikamiyor. Eskiden bunu tiklamayi
       yakalayarak asiyorduk, ama PARMAKLA KAYDIRMA icin seridin dokunusu
       gercekten almasi gerek -- yakalama numarasi orada ise yaramaz.
       Bu yuzden kutunun kendisini ortunun ustune aliyoruz. Rozetler
       (.card__badge) .card__content icinde ve orasi yigin baglami
       yaratmiyor, bu yuzden CSS'te onlara 3 verip ustte tutabiliyoruz. */
    if (getComputedStyle(box).zIndex === 'auto') box.style.zIndex = '2';

    var cs = getComputedStyle(img);

    /* SERIT: tarayicinin kendi yatay kaydiricisi. */
    var serit = document.createElement('div');
    serit.className = 'cz-gal__serit';
    box.appendChild(serit);

    function slayt(url, tembel, kaynak) {
      var s = document.createElement('div');
      s.className = 'cz-gal__slayt';
      var im = document.createElement('img');
      im.className = 'cz-gal__im';
      im.alt = '';
      im.decoding = 'async';
      if (tembel) im.loading = 'lazy';
      im.style.objectFit = cs.objectFit;
      im.style.objectPosition = cs.objectPosition;
      /* Kaynak verilirse duyarli adres listesi de kopyalanir: tarayici ikisi
         icin AYNI dosyayi secer, boylece ikinci bir indirme olmaz. */
      if (kaynak) {
        var ss = kaynak.getAttribute('srcset'); if (ss) im.setAttribute('srcset', ss);
        var sz = kaynak.getAttribute('sizes'); if (sz) im.setAttribute('sizes', sz);
      }
      im.src = url;
      s.appendChild(im);
      serit.appendChild(s);
      return im;
    }

    var layer = document.createElement('div');
    layer.className = 'cz-gal';
    /* <a> icine <button> konamaz (sekme ve karusel kartlari bir baglantinin
       icinde), bu yuzden role="button" tasiyan span. */
    layer.innerHTML =
      '<span class="cz-gal__btn cz-gal__btn--prev" role="button" tabindex="0" aria-label="Onceki fotograf">' + ICON + '</span>' +
      '<span class="cz-gal__btn cz-gal__btn--next" role="button" tabindex="0" aria-label="Sonraki fotograf" style="transform:translateY(-50%) rotate(180deg)">' + ICON + '</span>';
    box.appendChild(layer);

    var st = { i: 0, urls: null, sozu: null, dots: null, dolduruldu: false };

    /* ISTENEN GENISLIK: kart ekranda ne kadarsa o kadar, ekran yogunlugu
       carpani ile. 300px'lik bir kart 2x ekranda 600 ister, 1000 degil. */
    var gen = 0;
    function boyutlu(url) {
      if (!gen) {
        var w = Math.round(box.getBoundingClientRect().width) || 400;
        var hedefW = w * Math.min(window.devicePixelRatio || 1, 2);
        gen = KADEME[KADEME.length - 1];
        for (var k = 0; k < KADEME.length; k++) { if (KADEME[k] >= hedefW) { gen = KADEME[k]; break; } }
      }
      return sized(url, gen);
    }

    /* Ilk slayt: tarayicinin AZ ONCE bastigi adres, yani onbellekten aninda
       gelir, ek istek yok. Cozuldukten sonra temanin kendi <img>'ini
       gizliyoruz -- gizlemezsek altta sabit durur ve kayarken "eski gorsel
       yerinde kaldi" hissi verir. opacity kullaniyoruz, display degil:
       eleman akista kaliyor, kartin yuksekligini o belirliyor.

       Kopya temanin kendi <img>'ini birebir kopyalar: ayni srcset, ayni
       sizes, ayni loading. Onceden slayt HER ZAMAN eager'di ve yalnizca src
       ozniteligini kullaniyordu; yani koleksiyon acilir acilmaz ekranin cok
       altindaki kartlarin gorselleri de iniyordu (24 kartta 22 erken istek
       olculdu) ve secilen olcu izgaranin sectiginden farkli olabildigi icin
       ayni gorsel iki kez inebiliyordu. Kopya artik tembelligi de miras
       aliyor, yani izgaranin kendi davranisi korunuyor.
       Temanin <img>'ini ancak kopya GERCEKTEN yuklendikten sonra gizliyoruz;
       yuklenemezse kart bos kalmasin. */
    var im0 = slayt(img.currentSrc || img.getAttribute('src'),
                    img.getAttribute('loading') === 'lazy', img);
    function gizleAsil() {
      (im0.decode ? im0.decode().catch(function () {}) : Promise.resolve())
        .then(function () { img.style.opacity = '0'; });
    }
    if (im0.complete && im0.naturalWidth) gizleAsil();
    else im0.addEventListener('load', gizleAsil, { once: true });

    function kurDots() {
      if (st.dots || !st.urls || st.urls.length < 2) return;
      st.dots = document.createElement('div');
      st.dots.className = 'cz-gal__dots';
      for (var k = 0; k < st.urls.length; k++) {
        st.dots.appendChild(document.createElement('span')).className = 'cz-gal__dot';
      }
      layer.appendChild(st.dots);
      boya(st.i);
    }
    function boya(i) {
      if (!st.dots) return;
      [].forEach.call(st.dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
    }

    /* Kalan slaytlar bir kez ekleniyor. loading="lazy" sayesinde tarayici
       yalnizca yaklasanlari indiriyor: 13 mockup'i pesinen cekmiyoruz. */
    function doldur(urls) {
      if (st.dolduruldu) return;
      st.dolduruldu = true;
      for (var k = 1; k < urls.length; k++) slayt(boyutlu(urls[k]), k > 1);
      kurDots();
      card.classList.add('cz-gal-on');
    }

    function veri() {
      if (st.sozu) return st.sozu;
      var h = handleOf(card);
      if (!h) { st.sozu = Promise.resolve(null); return st.sozu; }
      st.sozu = load(h).then(function (urls) {
        if (!urls || urls.length < 2) { layer.remove(); return null; }
        st.urls = urls;
        doldur(urls);
        return urls;
      });
      return st.sozu;
    }

    /* ON YUKLEME: tiklamadan once. Masaustunde imlec karta gelince, mobilde
       parmak degince. Sayfa acilirken hicbir ek istek yok. */
    function onIstek() { veri(); }
    card.addEventListener('pointerenter', onIstek, { passive: true });
    card.addEventListener('touchstart', onIstek, { passive: true });

    function git(yon) {
      veri().then(function (urls) {
        if (!urls) return;
        serit.scrollBy({ left: yon * (box.clientWidth || serit.clientWidth), behavior: 'smooth' });
      });
    }

    /* Noktalar kaydirmayi takip ediyor: parmakla da, okla da ayni yerden
       guncelleniyor. Her kaydirma olayinda degil, bir sonraki karede. */
    var bekliyor = false;
    serit.addEventListener('scroll', function () {
      if (bekliyor) return;
      bekliyor = true;
      requestAnimationFrame(function () {
        bekliyor = false;
        var w = serit.clientWidth || 1;
        var i = Math.round(serit.scrollLeft / w);
        if (i !== st.i) { st.i = i; boya(i); }
      });
    }, { passive: true });

    function bind(el, yon) {
      el.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); git(yon); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); e.stopPropagation(); git(yon); }
      });
    }
    bind(layer.querySelector('.cz-gal__btn--prev'), -1);
    bind(layer.querySelector('.cz-gal__btn--next'), 1);

    /* Serit artik ortunun ustunde oldugu icin gorsele dokunmak kartin kendi
       baglantisini acmiyor; onu biz iletiyoruz. Ama SURUKLEME tiklama
       sayilmamali: parmagini kaydirip birakan biri urun sayfasina
       dusmemeli. Baslangictaki kaydirma konumunu ve imlec yerini
       karsilastiriyoruz. */
    var basX = 0, basKaydirma = 0;
    serit.addEventListener('pointerdown', function (e) {
      basX = e.clientX; basKaydirma = serit.scrollLeft;
    }, { passive: true });
    serit.addEventListener('click', function (e) {
      var surukledi = Math.abs(serit.scrollLeft - basKaydirma) > 4 || Math.abs(e.clientX - basX) > 6;
      if (surukledi) { e.preventDefault(); e.stopPropagation(); return; }
      if (bag && bag.getAttribute('href')) {
        e.preventDefault(); e.stopPropagation();
        window.location.href = bag.href;
      }
    });

    /* Guvenlik agi: yigin sirasini yukseltemedigimiz bir kart tipi cikarsa
       (tema guncellemesi, farkli bir sablon) ok tiklamasi yine de calissin
       diye yakalama asamasinda koordinatla esliyoruz. Normalde bu hic
       devreye girmez, cunku oklar artik dogrudan tiklamayi aliyor. */
    card.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.cz-gal__btn')) return;
      var pv = layer.querySelector('.cz-gal__btn--prev');
      var nx = layer.querySelector('.cz-gal__btn--next');
      if (!pv || !nx) return;
      var uzerinde = function (el) {
        var r = el.getBoundingClientRect();
        return r.width > 0 && e.clientX >= r.left && e.clientX <= r.right &&
               e.clientY >= r.top && e.clientY <= r.bottom;
      };
      if (uzerinde(nx)) { e.preventDefault(); e.stopPropagation(); git(1); }
      else if (uzerinde(pv)) { e.preventDefault(); e.stopPropagation(); git(-1); }
    }, true);

    return st;
  }

  function scan(root) {
    TYPES.forEach(function (t) {
      [].forEach.call((root || document).querySelectorAll(t.card), function (card) {
        if (card.dataset.czGal) return;
        var box = card.matches(t.box) ? card : card.querySelector(t.box);
        if (!box || box.querySelector('.cz-gal')) return;
        card.dataset.czGal = '1';
        build(card, box);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);

  /* Bolum duzenleyicide ve filtre/sayfalama sonrasi yeniden basilan kartlar.
     Gozlemci kendi ekledigimiz elemanlari da gorur; her mutasyonda taramak
     yerine bir sonraki kareye erteleyip tek sefer tariyoruz. */
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  var queued = false;
  var mo = new MutationObserver(function (muts) {
    if (queued) return;
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) {
        queued = true;
        requestAnimationFrame(function () { queued = false; scan(document); });
        return;
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
